/** Событие: refresh отозван (OAuth invalid_grant) — AuthProvider подписывается и делает logout. */
const REFRESH_TOKEN_REVOKED_EVENT = "leninka:oauth-refresh-invalid-grant"

export const dispatchRefreshTokenRevoked = () => {
  if (typeof window === "undefined") return
  window.dispatchEvent(new CustomEvent(REFRESH_TOKEN_REVOKED_EVENT))
}

export const subscribeRefreshTokenRevoked = (handler: () => void) => {
  if (typeof window === "undefined") return () => {}
  window.addEventListener(REFRESH_TOKEN_REVOKED_EVENT, handler)
  return () => window.removeEventListener(REFRESH_TOKEN_REVOKED_EVENT, handler)
}
